




















import { Component, Vue } from "vue-property-decorator";
import { CrudService } from "../../core/services/crudService";
import { Settings } from "../../core/services/configService";
import { CustomerHelper } from "../../crm/helpers/customerHelper";
import { ProgramPackTexts } from "../../bookings/programPackTexts";
import ProgramProgress from "./ProgramProgress.vue";
import ProgramPill from "./ProgramPill.vue";
import ProgramMeta from "./ProgramMeta.vue";
import CzTitle from "../cz/CzTitle.vue";
import CzLink from "../cz/CzLink.vue";

const InProgress = 2;

@Component({
  components: { ProgramProgress, ProgramPill, ProgramMeta, CzTitle, CzLink },
})
export default class ProgramsInProgress extends Vue {
  enrollments: any[] = [];
  texts = ProgramPackTexts;

  t(key: string): string {
    return this.$t(key).toString();
  }

  doneText(e: any): string {
    return this.t("{0} of {1} appointments done")
      .replace("{0}", String(ProgramPackTexts.done(e)))
      .replace("{1}", String(ProgramPackTexts.sessions(e)));
  }

  async mounted() {
    const cid = CustomerHelper.getStoredCustomer();
    if (!cid) return;
    const data = await new CrudService().httpGet(`${Settings.HostName}/api/publicprogrampacks/customer/${cid}`);
    this.enrollments = data && data.ok ? data.data.filter((e: any) => e.status === InProgress) : [];
  }
}
